const gift = {
  add_new: "商品追加",
  edit_gift: "商品編集",
  name: "商品名",
  name_placeholder: "商品名を入力",
  gift_type: "商品種類",
  start_date: "開始日",
  end_date: "終了日",
  detail: "詳細情報",
  detail_placeholder: "詳細を入力",
  point_exchange: "交換ポイント数",
  point_exchange_placeholder: "ポイント数を入力",
  participants: "受講生",
  student_coach: "コーチ",
  point: "ポイント",
  limit: "商品上限 ",
  limit_placeholder: "上限を入力",
  limit_exist: "制限あり",
  no_limit: "制限なし",
  video: "動画",
  name_video: "動画",
  name_video_placeholder: "動画名を入力",
  text_upload: "ファイルを選択",
  text_sub_upload: "またはここにファイルをドロップ",
  add_video: "追加",
  mail_notification: "メール案内文",
  mail_notification_placeholder: "案内文を入力",
  cancel: "キャンセル",
  save_draft: "下書き保存",
  save: "保存",
  name_required: "商品名を入力してください。",
  save_draft_success: "ご指定の商品を非公開しました。",
  save_public_success: "ご指定の商品を公開しました。",
  save_gift_success: "新しい商品を作成しました。",
  edit_gift_success: "ご指定の商品を更新しました。",
  upload_video_success: "動画をアップロードしました。",
  gift_type_dialog: {
    title: "商品種類",
    name: "商品種類名",
    name_placeholder: "種類名を入力",
    add: "追加",
    cancel: "キャンセル",
    gift_type_delete: "種類削除",
    gift_type_delete_confirm: "ご指定の種類を削除します。よろしいでしょうか。",
    gift_type_delete_cancel: "キャンセル",
    gift_type_delete_yes: "はい",
    add_gift_type_success: "新しい商品種類を追加しました。",
    edit_gift_type_success: "ご指定の商品種類を更新しました。",
    delete_gift_type_success: "ご指定の商品種類を削除しました。",
    gift_type_name_exist: "ご登録の商品種類は既に存在しますため、他の種類でご登録ください。",
  },
  required: {
    gift_type_id: "商品種類を選択してください。",
    points_required_for_student: "交換ポイント数を入力してください。",
    points_required_for_teacher: "交換ポイント数を入力してください。",
    total_quantity: "商品上限を入力してください。",
    email_content: "メール案内文を入力してください。",
    video_name_required: "動画名を入力してください。",
    video_file_required: "動画をアップロードしてください。",
  },
};

export default gift;